<template>
    <div class="pdc-container">
        <div class="pdc-toolbar">
            <div class="pdc-legend">
                <template v-if="pdSelectedStat !== 'productivity' && pdSelectedStat !== 'feedback'">
                    <button class="pdc-legend-item" @click="openCalculationTypeDropdown($event)">
                        <i :class="calculationTypeIcon"
                           :style="{color: specialViewActive ? 'var(--contrast-5)' : calculationTypeColor}"/>
                        <span>{{ calculationTypeText }}</span>
                        <!--
                        <ul class="select-dropdown">
                            <li class="select-dropdown-item" v-for="item of Object.values(calculationTypeOptions)"
                                :key="item.value"
                                @click="chartSettings.calculationMode = item.value">
                                <i class="fas" :class="item.icon" :style="{backgroundColor: item.color}"></i>
                                <span>{{ item.label }}</span>
                            </li>
                        </ul>
                        -->
                    </button>
                    <button class="pdc-legend-item" @click="cycleIndicators">
                        <i :class="indicatorIcon"
                           :style="{color: specialViewActive ? 'var(--contrast-5)' : '#1a1a1a'}"/>
                        <span>{{ selectedIndicatorName }}</span>
                    </button>
                    <button class="pdc-legend-item" @click="cycleLineMode">
                        <i :class="selectedLineMode.icon"
                           style="--fa-secondary-color: black"
                           :style="{color: specialViewActive ? 'var(--contrast-5)' : selectedLineMode.color}"/>
                        <span>{{ selectedLineMode.label }}</span>
                    </button>
                    <button class="pdc-legend-item" @click="cyclePersonellMode">
                        <i :class="selectedPersonellMode.icon"
                           :style="{color: specialViewActive ? 'var(--contrast-5)' : selectedPersonellMode.color}"/>
                        <span>{{ selectedPersonellMode.label }}</span>
                    </button>
                    <button v-if="hasMarketPermission" class="pdc-legend-item"
                            @click="marketTooSmall || marketError ? undefined : toggleDisplayData('lines', 'market')"
                            v-tooltip="() => marketTooSmall ? $t('roster.comp.noDataForMarketComp') : marketError ? $t('roster.comp.loadMarketDataError') : undefined"
                            :style="{cursor: marketTooSmall || marketError ? 'default' : 'pointer'}">
                        <i class="fal fa-chart-pie" v-if="marketTooSmall || marketError"
                           style="color: var(--contrast-5); cursor: default"/>
                        <i class="fa fa-chart-pie" v-else
                           :style="{color: hasDisplayData('lines', 'market') ? 'rgba(40, 200, 224, 0.75)' : 'var(--contrast-5)'}"/>
                        <span>{{ $t('store.settings.market') }}</span>
                    </button>
                    <!--
                    <button class="pdc-legend-item" @click="toggleDisplayData('bars', 'assigned')">
                        <i class="fa fa-user"
                           :style="{color: hasDisplayData('bars', 'assigned') ? '#6d8d23' : 'var(--contrast-5)'}"/>
                        <span>Personal</span>
                    </button>
                    <button class="pdc-legend-item" @click="toggleDisplayData('bars', 'actual')">
                        <i class="fa fa-user-check"
                           :style="{color: hasDisplayData('bars', 'actual') ? '#e86e13' : 'var(--contrast-5)'}"/>
                        <span>Gestempelt</span>
                    </button>
                    <button class="pdc-legend-item" @click="toggleDisplayData('bars', 'overstaffed')">
                        <i class="fa fa-users"
                           :style="{color: hasDisplayData('bars', 'overstaffed') ? '#ee134d' : 'var(--contrast-5)'}"/>
                        <span>Überbesetzt</span>
                    </button>
                    <button class="pdc-legend-item" @click="toggleDisplayData('bars', 'free')">
                        <i class="far fa-users"
                           :style="{color: hasDisplayData('bars', 'free') ? '#545454' : 'var(--contrast-5)'}"/>
                        <span>Frei</span>
                    </button>
                    -->
                </template>
                <button class="pdc-legend-item" @click="resetViewMode" v-else>
                    <i class="fa fa-times" :style="{color: 'var(--contrast-5)'}"/>
                    <span>{{ $t('global.ui.close') }}</span>
                </button>

                <button class="pdc-legend-item" @click="toggleViewMode('productivity')">
                    <i class="fa fa-briefcase"
                       :style="{color: hasDisplayData('lines', 'productivity') ? '#f7d600' : 'var(--contrast-5)'}"/>
                    <span>{{ $t('roster.view.productivity') }}</span>
                </button>
                <button v-if="mode === 'month'" class="pdc-legend-item" @click="toggleViewMode('feedback')">
                    <i class="fa fa-heart"
                       :style="{color: hasDisplayData('lines', 'feedback') ? '#fb386c' : 'var(--contrast-5)'}"/>
                    <span>{{ $t('roster.comp.satisfaction') }}</span>
                </button>
            </div>
            <div class="pdc-button-container">
                <button v-if="false" style="background-color: #e86e13; color: white;">$t('global.ui.edit')</button>
                <button v-if="false" style="background-color: #688590; color: white;">$t('roster.comp.optimize')</button>
                <buttonc icon="fa-sliders-h"
                         style="color: var(--contrast-4); background: none; margin-left: 2rem; margin-right: 0;"
                         @click="openSettingsPopup()"/>
            </div>
        </div>
        <div v-if="loading" class="pdc-loading-container">
            <div class="pdc-loading-bar" v-for="bar of loadingBars" :key="bar.key" :style="bar.style"></div>
        </div>
        <div v-else-if="displayError" class="pdc-error-container">
            <md-kpi-chart :bar-width="barWidth"
                          :chart-data="errorViewChartData"
                          :background-color="nightMode ? [86,86,86,1] : [242,242,242,1]"
                          :show-legend="false"
                          :dense="mode === 'monthHourly'"
                          class="pd-kpi-chart pd-kpi-chart--blurred"/>
            <span class="pdc-error-heading"><i class="fas fa-exclamation-circle"/></span>
            <p>{{ pdSelectedStat === 'feedback' ? sumError.message : error.message }}</p>
            <button @click="refresh">
                {{ $t('roster.comp.reload') }}&nbsp;
                <i class="fas fa-sync-alt"/>
            </button>
        </div>
        <template v-else>
            <div v-if="Number.isInteger(selectedIndex)"
                 class="selection-stripe"
                 :style="{width: selectionStripeWidth + 'px'}"/>

            <md-kpi-chart v-if="chartData !== null"
                          :bar-width="barWidth"
                          :chart-data="chartData"
                          :selected-index="selectedIndex"
                          :background-color="nightMode ? [86,86,86,1] : [242,242,242,1]"
                          :show-legend="false"
                          :dense="mode === 'monthHourly'"
                          @barClick="onBarClick"
                          @barDblClick="onBarDblClick"
                          @chartUpdate="onChartUpdate"
                          class="pd-kpi-chart"/>

        </template>
    </div>
</template>

<script>
import moment from 'moment';
import * as pdHelper from './pdhelper';
import { mapGetters } from 'vuex';

export default {
    name: 'PersonnelDeploymentChart',
    props: {
        initBarWidth: { // a fixed width for the bars or null for dynamic width
            type: Number,
            default: () => null,
        },
        day: Object, // moment object of the day or null
        dayModeHours: Number,
        week: Object, // moment object of the week or null
        currentWeekShiftTemplateMap: Object, // map of shift templates for the current week; should be cached based on week prop
        chartPaddingRight: {
            type: Number,
            default: () => 0,
        },
        considerPreviousMonth: Boolean,
        forceLoading: Boolean,
    },
    data() {
        return {
            loading: true,
            error: null,
            marketError: null,
            sumError: null,

            pdHelper: null,

            chartData: null, // Data that the md-kpi-graph component uses
            rawChartData: {}, // Raw data that is
            monthData: {},
            dayData: {},

            // dataMaps: {}, // Combined maps from pdhelper.calculateRawChartData, can be updated individually to reflect changes in the chart
            detailStats: {}, // Stats for the detail view

            selectedIndex: null,

            barWidth: this.initBarWidth || 51,

            planningIndicatorTypeMap: {},
            planningIndicators: [],
            meoData: [],
            vlhData: [],
            marketPlannedWorkTimeData: [],

            monthlyPlanningIndicators: [],

            sumStats: [],
            sumStatsForMonth: [],

            monthlyRegularWorkTime: [],

            pastComparisonData: {
                dailySumStats: null,
                monthlyRegularWorkTime: null,
            },

            chartSettingsVisible: false,
            chartSettings: {
                calculationMode: 'demand',
                absenceHoursPercentage: 0, // e.g. 0.05 to subtract 5% from monthly workTime for absences
                defaultShiftLength: 8,
                showHourlyBars: false,
                showDayQuarterHourlyBars: false,
                includePrevMonthTime: true,
                useExistingPreferences: true,
                useMeanShiftLength: true,
                selectedIndicatorTypeId: null,
                selectedMarketMode: 2, // default to whole market (Q)
                splitPredictionLine: false,
                selectedEmployeeLevels: [ 1 ], // only crew per default
                subtractBreaks: true,
                comparisonPeriod: 1,
                displayHours: false,
                displayData: {
                    lines: [ 'actual', 'planned' ],
                    bars: [ 'actual', 'assigned', 'overstaffed', 'free' ],
                    selectedStat: ( this.selectedStat || { stat: null } ).stat,
                },
                version: 8,
            },
        };
    },
    mounted() {
        if (!this.initBarWidth) {
            this.$nextTick().then(this.updateBarWidth);
            window.addEventListener('resize', this.updateBarWidth);
        }
        this.refresh();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateBarWidth);
    },
    watch: {
        async mode() {
            await this.refresh();
        },
        forceLoading(newVal) {
            this.loading = newVal;
        },
        rawData(newVal) {
            if (newVal) {
                this.detailStats = this.calculateStats(newVal);
                this.chartData = this.calculateDisplayableChartData(newVal);
            }
        },
        initBarWidth() {
            window.removeEventListener('resize', this.updateBarWidth);
            this.updateBarWidth();
            window.addEventListener('resize', this.updateBarWidth);
        },
        nightMode() {
            // no full refresh needed -> update only night mode
            // this.chartData = this.getChartData();
            // this.calculateChartDataNew().catch(() => {});
            this.$forceUpdate();
        },
        pdSelectedStat(newVal) {
            this.$set(this.chartSettings.displayData, 'selectedStat', newVal);
            this.calculateChartData().catch(() => {
            });
        },
        rosterFromTo() {
            if (!this.loading) {
                this.refresh();
            }
        },
        actualShiftMap() {
            this.selectedIndex = null;
            // this.chartData = this.getChartData();
            this.calculateChartData().catch(() => {
            });
            // this.onDetailDataChange();
        },
        planShiftMap() {
            this.selectedIndex = null;
            // this.chartData = this.getChartData();
            this.calculateChartData().catch(() => {
            });
            // this.onDetailDataChange();
        },
        storeId(newVal, oldVal) {
            if (!this.loading && oldVal !== newVal) {
                this.refresh();
            }
        },
        showTruncWeeks() {
            this.selectedIndex = null;
            // this.chartData = this.getChartData();
            this.calculateChartData().catch(() => {
            });
            // this.onDetailDataChange();
            // if (!this.showTruncWeeks)
            //   setTimeout(() => this.calculateChartDataNew()/*this.chartData = this.getChartData()*/);
        },
        includeMgmtInProductivity() {
            // this.chartData = this.getChartData();
            this.calculateChartData().catch(() => {
            });
            // this.onDetailDataChange();
        },
        day() {
            this.refresh();
        },
        dayModeHours() {
            this.refresh();
        },
        week() {
            this.refresh();
        },
        currentWeekShiftTemplateMap() {
            if (this.forceLoading) return;
            this.refresh();
        },
        considerPreviousMonth(newVal, oldVal) {
            if (newVal == null || newVal === oldVal) {
                return;
            }
            this.$set(this.chartSettings, 'includePrevMonthTime', newVal);
            this.refresh();
        },
    },
    computed: {
        ...mapGetters([ 'storeId', 'rosterFromTo', 'rosterVisibilityState', 'spotMap', 'planShiftMap', 'actualShiftMap',
            'actualBreakMap', 'employeeMap', 'employeeWorkbalanceMap', 'employeeContractMap', 'allowedContractMap',
            'storeSettings', 'shiftTimeByDayMap', 'employeePreferenceMap', 'allowedContractMap', 'permissions',
            'isSuperUser', 'pdDataMaps', 'pdSelectedStat', 'storeSettings' ]),

        mode() {
            if (this.day && this.chartSettings.showDayQuarterHourlyBars) {
                return 'dayQuarterHourly';
            } else if (this.day) {
                return 'day';
            } else if (this.week) {
                return 'week';
            } /*else if (this.chartSettings.showHourlyBars) {
        return 'monthHourly';
      } */ else {
                return 'month';
            }
        },

        loadingBars() {
            const loadingBars = [];
            const barCount = moment(this.endOfMode).diff(this.startOfMode, pdHelper.UNIT_MAP[this.mode], false) / pdHelper.INTERVAL_MAP[this.mode];
            const paddingRatio = this.mode === 'monthHourly' ? 1 : 2.5;

            for (let i = 0; i < barCount; i++) {
                const clientHeight = this.$el ? this.$el.clientHeight : 280;
                loadingBars.push({
                    key: this.mode + i,
                    style: {
                        width: `${this.barWidth / paddingRatio}px`,
                        height: `${clientHeight / 2 + ( clientHeight / 4 ) * Math.sin(i / 2)}px`,
                        animationDelay: `${1.25 * ( i / barCount )}s`,
                        margin: `1rem ${( this.barWidth - this.barWidth / paddingRatio ) / 2}px`,
                    },
                });
            }
            return loadingBars;
        },

        displayError() {
            if (this.sumError && this.pdSelectedStat === 'feedback') return true;
            if (this.pdSelectedStat === 'productivity')
                return !!( this.error && this.error.requestType === 'planningIndicators' );
            const error = this.error;
            return !!error && (
                ( error.requestType === 'meoData' && this.chartSettings.calculationMode === 'meo' ) ||
                ( error.requestType === 'vlhData' && this.chartSettings.calculationMode === 'vlh' ) ||
                ( error.requestType === 'planningIndicators' && this.chartSettings.calculationMode === 'demand' ) ||
                !error.requestType
            )
        },

        errorViewChartData() {
            const chartData = {
                orangeValues: [],
                greenValues: [],
                redValues: [],
                grayValues: [],
                lineValues: [],
                predictionLineValues: [],
                yellowLineValues: [],
                redLineValues: [],
                blueLineValues: [],
                blueAreaValues: [],
                datasetLabels: {},
                datasetColors: {
                    orange: '#e86e13',
                    green: '#879d53',
                },
                barLabels: [],
                barLabelColors: [],
                barIcons: [],
                barTooltips: [],
                separators: [],
                horizontalLines: undefined,
                predictionStart: 0,
                currentDayIndex: null,
                lineDotSize: 0,
                padding: {
                    top: 17,
                },
            };

            let index = 0;
            const currentDate = moment();

            let actualShifts = Object.values(this.actualShiftMap);
            let plannedShifts = Object.values(this.planShiftMap);
            let freeShiftMap = this.pdHelper.filterShifts(plannedShifts.filter(s => !s.employeeId), this.startOfMode, this.endOfMode, this.mode);
            let assignedShiftMap = this.pdHelper.filterShifts(plannedShifts.filter(s => !!s.employeeId), this.startOfMode, this.endOfMode, this.mode, []);
            let actualShiftMap = this.pdHelper.filterShifts(actualShifts, this.startOfMode, this.endOfMode, this.mode, []);

            for (const date = moment(this.renderFrom);
                 date.isBefore(this.renderTo);
                 date.add(pdHelper.INTERVAL_MAP[this.mode], pdHelper.UNIT_MAP[this.mode])) {
                if (date.isSame(currentDate, pdHelper.UNIT_MAP[this.mode]))
                    chartData.currentDayIndex = chartData.predictionStart = index + 1;

                const key = date.format(pdHelper.KEY_FORMATTERS[this.mode]);
                chartData.orangeValues[index] = actualShiftMap[key] ? actualShiftMap[key].length : 0;
                chartData.greenValues[index] = Math.max(
                    assignedShiftMap[key] ? assignedShiftMap[key].length - chartData.orangeValues[index] : 0,
                    0
                );
                chartData.grayValues[index] = freeShiftMap[key] ? freeShiftMap[key].length : 0;
                chartData.lineValues[index] = 0;
                chartData.predictionLineValues[index] = 0;
                chartData.blueAreaValues[index] = [ 0, 0 ];
                chartData.barLabels[index] = '';

                index += 1;
            }

            return chartData;
        },

        dataKey() {
            if (this.mode === 'day') {
                return this.day.format(pdHelper.KEY_FORMATTERS.day);
            } else if (this.mode === 'week') {
                return this.week.format(pdHelper.KEY_FORMATTERS.week);
            } else { // month, monthHourly
                const monthStart = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                return monthStart.format(pdHelper.KEY_FORMATTERS.month);
            }
        },

        dataMaps() {
            const cachingKey = this.createCachingKey();
            return this.pdDataMaps(cachingKey);
        },

        rawData() {
            if (this.dataMaps)
                return this.calculateRawData(this.dataMaps);
            else
                return null;
        },

        nightMode() {
            return this.$store.state.nightMode;
        },
        indicatorIcon() {
            const indicatorIconMap = {
                0: 'fa fa-chart-area', // Default icon
                1: 'fa fa-euro-sign', // Umsatz
                2: 'fad fa-euro-sign', // Umsatz (Netto)
                3: 'fad fa-user-friends', // Gäste
            };
            if (this.chartSettings.calculationMode === 'meo' || this.chartSettings.calculationMode === 'vlh')
                return indicatorIconMap[0];
            let category = 0;
            if (this.chartSettings.selectedIndicatorTypeId && this.planningIndicatorTypeMap[this.chartSettings.selectedIndicatorTypeId]) {
                category = this.planningIndicatorTypeMap[this.chartSettings.selectedIndicatorTypeId].category;
                return indicatorIconMap[category];
            }
            return indicatorIconMap[category];
        },
        selectionStripeWidth() {
            if (!Number.isInteger(this.selectedIndex)) return 0;
            return this.selectedIndex * this.barWidth + 6;
        },
        showTruncWeeks() {
            return !this.rosterVisibilityState.visibilityMonthOnly;
        },
        // Unnecessary, as this can be done using the spot filter
        // includeMgmtInProductivity() {
        //   return !this.rosterVisibilityState.visibilityProductivityIncludeMgmt;
        // },
        startDate() {
            return this.showTruncWeeks ? moment(this.rosterFromTo.from) : moment([ this.rosterFromTo.year, this.rosterFromTo.month ]);
        },
        endDate() {
            return this.showTruncWeeks ? moment(this.rosterFromTo.to) : moment(this.startDate).add(1, 'month').startOf('month');
        },
        startOfMode() {
            let startDate;
            if (this.mode === 'week') {
                startDate = moment(this.week).startOf('week');
            } else if (this.mode === 'day' || this.mode === 'dayQuarterHourly') {
                startDate = moment(this.day).startOf('day');
            } else {
                startDate = moment([ this.rosterFromTo.year, this.rosterFromTo.month ]);
            }
            return startDate;
        },
        endOfMode() {
            let endDate;
            if (this.mode === 'week') {
                endDate = moment(this.startOfMode).add(1, 'week').startOf('day');
            } else if (this.mode === 'day' || this.mode === 'dayQuarterHourly') {
                endDate = moment(this.startOfMode).add(this.dayModeHours, 'hours');
            } else {
                endDate = moment(this.startOfMode).add(1, 'month').startOf('month');
            }
            return endDate;
        },
        renderFrom() {
            if (this.mode !== 'month' && this.mode !== 'monthHourly') {
                return this.startOfMode;
            } else {
                return this.startDate;
            }
        },
        renderTo() {
            if (this.mode !== 'month' && this.mode !== 'monthHourly') {
                return this.endOfMode;
            } else {
                return this.endDate;
            }
        },

        approxChartWidth() {
            return moment(this.endDate).diff(moment(this.startDate), 'days') * this.barWidth + 5;
        },

        calculationTypeOptions() {
            let options = {
                demand: { value: 'demand', label: this.$t('roster.comp.requirement'), icon: 'fa fa-coins', color: '#1a1a1a' },
            }
            if(this.storeSettings.enableMeo) {
                options['meo'] = { value: 'meo', label: this.$t('shift.main.meo'), icon: 'fa fa-users', color: '#428cff' };
            }
            if(this.storeSettings.enableVlh) {
                options['vlh'] = { value: 'vlh', label: this.$t('shift.main.vlh'), icon: 'fa fa-users', color: '#428cff' };
            }
            return options;
        },

        calculationTypeText() {
            return this.calculationTypeOptions[this.chartSettings.calculationMode]
                ? this.calculationTypeOptions[this.chartSettings.calculationMode].label
                : '--';
        },

        calculationTypeColor() {
            return this.calculationTypeOptions[this.chartSettings.calculationMode]
                ? this.calculationTypeOptions[this.chartSettings.calculationMode].color
                : 'var(--contrast-5)';
        },

        calculationTypeIcon() {
            return this.calculationTypeOptions[this.chartSettings.calculationMode]
                ? this.calculationTypeOptions[this.chartSettings.calculationMode].icon
                : 'fa fa-coins';
        },

        lineModeButtonOptions() {
            return [
                { value: 0, label: this.$t('roster.comp.targetActual'), icon: 'fas fa-chart-line', color: '#1a1a1a', stringVal: 'combined' },
                { value: 1, label: this.$t('roster.comp.separate'), icon: 'fad fa-chart-line', color: '#8f00bd', stringVal: 'split' },
                { value: 2, label: this.$t('roster.comp.targetOnly'), icon: 'fas fa-chart-line', color: '#8f00bd', stringVal: 'planned' },
                { value: 3, label: this.$t('roster.comp.actualOnly'), icon: 'fas fa-chart-area', color: '#1a1a1a', stringVal: 'actual' },
            ];
        },

        selectedLineMode() {
            if (this.chartSettings.splitPredictionLine) {
                return this.lineModeButtonOptions[1];
            } else if (this.chartSettings.displayData.lines.includes('actual')
                && this.chartSettings.displayData.lines.includes('planned')) {
                return this.lineModeButtonOptions[0];
            } else if (this.chartSettings.displayData.lines.includes('planned')) {
                return this.lineModeButtonOptions[2];
            } else {
                return this.lineModeButtonOptions[3];
            }
        },

        personellModeButtonOptions() {
            return [
                { value: 0, label: this.$t('roster.comp.punched'), icon: 'fas fa-user-check', color: '#e86e13' },
                { value: 1, label: this.$t('roster.comp.assigned'), icon: 'fas fa-user', color: '#6d8d23' },
            ];
        },

        selectedPersonellMode() {
            if (this.chartSettings.displayData.bars.includes('actual')) {
                return this.personellModeButtonOptions[0];
            } else {
                return this.personellModeButtonOptions[1];
            }
        },

        specialViewActive() {
            return this.chartSettings.displayData.lines.includes('productivity')
                || this.chartSettings.displayData.lines.includes('feedback');
        },

        settingsIndicatorSelectOptions() {
            return Object.values(this.planningIndicatorTypeMap || {})
                .filter(({ category }) => !!category)
                .map(value => ( {
                    value: value.id,
                    text: value.name,
                } ));
        },
        settingsMarketSelectOptions() {
            return [
                // { value: 1, text: this.$t('roster.comp.totalMarket') },
                { value: 2, text: this.$t('roster.comp.totalMarket') }, // Still Quartile Calculation!
                // { value: 3, text: this.$t('roster.comp.salesOriented') },
                { value: 4, text: this.$t('roster.comp.salesOriented') }, // Still Quartile Calculation!
            ];
        },
        selectedIndicatorName() {
            let name = this.$t('roster.view.keyFigure');
            if (this.chartSettings.selectedIndicatorTypeId && this.planningIndicatorTypeMap[this.chartSettings.selectedIndicatorTypeId]) {
                name = this.planningIndicatorTypeMap[this.chartSettings.selectedIndicatorTypeId].name;
            }
            return name;
        },

        hasMarketPermission() {
            if (this.isSuperUser)
                return true;

            let res = false;

            for (const perms of Object.values(this.permissions)) {
                if (perms.map(perm => perm.id).includes(80)) {
                    // can view market data
                    res = true;
                    break;
                }
            }

            return res;
        },

        marketTooSmall() {
            const marketData = this.marketPlannedWorkTimeData;
            if (!marketData || !marketData.length) return false;
            return 'marketSize' in marketData[0] && marketData[0].marketSize < this.storeSettings.marketSizeLimit;
        },
    },
    methods: {
        async refresh() {
            this.loading = true;

            this.pdHelper = new pdHelper.PersonnelDeploymentHelpers(this.storeSettings, this.$rosterhelper, this.$helpers);

            this.onDetailDataChange(true);

            this.selectedIndex = null;
            this.marketPlannedWorkTimeData = [];
            if (!this.rosterFromTo || !this.$store.state.jwt || !this.$store.state.storeId) return;

            let settings = this.getLocalStorageSettings();
            if (settings && ( settings.version || -1 ) < this.chartSettings.version)
                settings = null;

            if (settings) {
                // if there are stored settings, update component data
                if(!this.storeSettings.enableMeo && settings.calculationMode === 'meo') {
                    settings.calculationMode = 'demand';
                }
                if(!this.storeSettings.enableVlh && settings.calculationMode === 'vlh') {
                    settings.calculationMode = 'demand';
                }
                this.chartSettings = { ...this.chartSettings, ...settings };
            } else {
                // if no stored settings, save the default settings -> no data update needed
                this.saveLocalStorageSettings();
            }

            if (this.considerPreviousMonth != null) {
                this.chartSettings.includePrevMonthTime = this.considerPreviousMonth;
            }

            // if (this.chartSettings.selectedSpots === null)
            //   this.chartSettings.selectedSpots = [ ...Object.values(this.spotMap).map(({ id }) => id), null ];

            if ([ 'feedback', 'productivity' ].includes(this.pdSelectedStat)
                || this.chartSettings.displayData.lines.includes('feedback')
                || this.chartSettings.displayData.lines.includes('productivity')) {
                this.resetViewMode();
            } else {
                this.$set(this.chartSettings.displayData, 'selectedStat', this.pdSelectedStat);
            }

            // Try cached data first
            // if (this.rawData && Object.keys(this.rawData).length > 0) {
            //     this.chartData = this.calculateDisplayableChartData(this.rawData);
            //     this.updateChartData();
            //     ( async () => {
            //         await this.$nextTick();
            //         this.loading = false;
            //     } )().catch((e) => console.error(e));
            // }

            this.planningIndicatorTypeMap = await this.$helpers.GetPlanningIndicatorTypeMap();

            if (!this.chartSettings.selectedIndicatorTypeId || !this.planningIndicatorTypeMap[this.chartSettings.selectedIndicatorTypeId]) {
                const planningIndicatorValues = Object.values(this.planningIndicatorTypeMap);
                // category 1 == sales
                const indicator = planningIndicatorValues.find(({ isDefault }) => isDefault)
                    || planningIndicatorValues.find(({ category }) => category === 1)
                    || planningIndicatorValues[0];
                if (indicator) {
                    this.$set(this.chartSettings, 'selectedIndicatorTypeId', indicator.id);
                }
            }

            this.updateBarWidth();

            const selectedEmployeeLevels = this.chartSettings.selectedEmployeeLevels.length === 1
                ? this.chartSettings.selectedEmployeeLevels[0]
                : null;

            ( async () => {
                // Load data
                if (this.mode === 'week') {
                    await this.loadWeekData(
                        this.week,
                        this.chartSettings.selectedIndicatorTypeId,
                        this.chartSettings.selectedMarketMode,
                        selectedEmployeeLevels,
                    );
                } else if (this.mode === 'day' || this.mode === 'dayQuarterHourly') {
                    await this.loadDayData(
                        this.day,
                        this.dayModeHours || 36,
                        this.chartSettings.selectedIndicatorTypeId,
                        this.chartSettings.selectedMarketMode,
                        this.chartSettings.showDayQuarterHourlyBars,
                        selectedEmployeeLevels,
                    );
                } else { // month, monthHourly
                    await this.loadMonthData(
                        this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1),
                        this.chartSettings.selectedIndicatorTypeId,
                        this.chartSettings.selectedMarketMode,
                        false, // this.chartSettings.showHourlyBars,
                        this.showTruncWeeks,
                        selectedEmployeeLevels,
                    );
                }

                await this.calculateChartData();

                this.updateBarWidth();
            } )().finally(() => {
                this.loading = false;
            });

            // Load past stats for comparison
            // this.loadComparisonData().catch((e) => console.error(e));
        },

        //
        // Load required data for current month/day/week
        //

        async loadMonthData(month, indicatorTypeId, marketMode, hourly = false, includeTruncWeeks = true, employeeLevel = null) {
            const from = moment(month).startOf('month');
            const to = moment(month).endOf('month').add(1, 'day').startOf('day');

            return this.loadAllData(from, to, indicatorTypeId, marketMode, hourly ? 'hourly' : 'daily', false, includeTruncWeeks, employeeLevel);
        },

        async loadWeekData(week, indicatorTypeId, marketMode, employeeLevel = null) {
            const from = moment(week).startOf('week');
            const to = moment(from).add(1, 'week');

            return this.loadAllData(from, to, indicatorTypeId, marketMode, 'hourly', true, false, employeeLevel);
        },

        async loadDayData(day, dayModeHours, indicatorTypeId, marketMode, quarterHourly = false, employeeLevel = null) {
            const from = moment(day).startOf('day');
            const to = moment(from).add(dayModeHours, 'hours');

            return this.loadAllData(from, to, indicatorTypeId, marketMode, quarterHourly ? 'quarterhourly' : 'hourly', true, false, employeeLevel);
        },


        /**
         * Load all data for the given mode
         * @param from
         * @param to
         * @param indicatorTypeId
         * @param marketMode
         * @param groupingMode {'daily' | 'hourly' | 'quarterHourly'}
         * @param loadMonthDataForSums
         * @param includeTruncWeeks
         * @returns {Promise<void>}
         */
        async loadAllData(from, to, indicatorTypeId, marketMode, groupingMode, loadMonthDataForSums = false, includeTruncWeeks = false, employeeLevel = null) {
            this.error = null;
            this.sumError = null;

            const indicatorType = this.planningIndicatorTypeMap[indicatorTypeId] || { category: 1 };
            const indicatorCategory = indicatorType.category;

            const monthFrom = moment(from).startOf('month');
            const monthTo = moment(from).endOf('month').add(1, 'day').startOf('day');

            // noinspection ES6MissingAwait
            const promises = [
                this.loadPlanningIndicators(from, to, indicatorTypeId, groupingMode),
                this.loadMarketData(from, to, groupingMode !== 'daily', marketMode, indicatorCategory, includeTruncWeeks, employeeLevel),
                this.loadMEOData(from, to, true, indicatorTypeId, groupingMode),
                this.loadMEOData(from, to, false, indicatorTypeId, groupingMode),
                this.loadVLHData(from, to, true, indicatorTypeId, groupingMode),
                this.loadVLHData(from, to, false, indicatorTypeId, groupingMode),
                this.loadSumStats(from, to, groupingMode),
                this.loadSumStats(monthFrom, monthTo, 'daily'),
                this.loadMonthlyRegularWorkTime(monthFrom, monthTo),
            ];

            const monthPlanningIndicatorIndex = promises.length;

            if (loadMonthDataForSums) {
                promises[monthPlanningIndicatorIndex] = this.loadPlanningIndicators(monthFrom, monthTo, indicatorTypeId, 'daily');
            }

            const data = await Promise.allSettled(promises);

            /*this.loadMarketData(from, to, hourly, marketMode, indicatorCategory, includeTruncWeeks)
                .then((data) => this.marketPlannedWorkTimeData = data)
                .then(() => this.calculateChartData())
                .catch((e) => {
                  this.$helpers.error('Fehler', 'Fehler beim Laden der Marktwerte');
                  console.error(e);
                });*/

            const promiseMapping = {
                0: 'planningIndicators',
                1: 'marketPlannedWorkTimeData',
                2: 'meoData',
                3: 'meoData',
                4: 'vlhData',
                5: 'vlhData',
                6: 'sumStats',
                7: 'sumStatsForMonth',
                8: 'monthlyRegularWorkTime',
            };
            promiseMapping[monthPlanningIndicatorIndex] = 'monthlyPlanningIndicators';

            const mappedData = {
                planningIndicators: [],
                marketPlannedWorkTimeData: [],
                meoData: [],
                vlhData: [],
                monthlyPlanningIndicators: [],
                sumStats: [],
                sumStatsForMonth: [],
                monthlyRegularWorkTime: [],
            };

            const errorMapping = {
                'planningIndicators': this.$t('roster.comp.indicatorValues'),
                'marketPlannedWorkTimeData': this.$t('roster.comp.marketValues'),
                'meoData': this.$t('roster.comp.meoData'),
                'vlhData': this.$t('roster.comp.vlhData'),
                'sumStats': this.$t('roster.comp.statistics'),
                'sumStatsForMonth': this.$t('roster.comp.monthStatistics'),
                'monthlyRegularWorkTime': this.$t('roster.comp.monthlyContractedWorkTime')
            };

            const errors = [];

            data.forEach(({ status, value, reason }, index) => {
                const requestType = promiseMapping[index];
                if (status === 'fulfilled') {
                    mappedData[requestType] = [ ...mappedData[requestType], ...value ];
                } else { // if (requestType !== 'sumStats') {
                    console.error(reason);
                    if (!errors.find((error) => error.requestType === requestType)) {
                        errors.push({
                            requestType,
                            message: this.$t('roster.error.errorLoading', [errorMapping[requestType]]),
                            code: reason.code,
                            reason,
                        });
                        if (requestType === 'planningIndicators' && this.chartSettings.calculationMode !== 'demand') {
                            this.$helpers.error(this.$t('global.notifications.error'), this.$t('roster.error.loadIndicator'));
                        }
                        if (requestType === 'meoData' && this.chartSettings.calculationMode !== 'meo') {
                            this.$helpers.error(this.$t('global.notifications.error'), this.$t('roster.error.loadMeo'));
                        }
                        if (requestType === 'vlhData' && this.chartSettings.calculationMode !== 'vlh') {
                            this.$helpers.error(this.$t('global.notifications.error'), this.$t('roster.error.loadVlh'));
                        }
                    }
                } // else {
                // this.$helpers.error('Fehler', 'Fehler beim Laden der Statistiken');
                // this.sumError = { message: 'Fehler beim Laden der Statistiken' };
                // }
            });

            if (errors.length > 1) {
                // this.$helpers.error('Fehler', this.$t('roster.error.loadPersonnelUsage'));
                this.error = { message: this.$t('roster.error.loadPersonnelUsage') };
            } else if (errors.length > 0) {
                this.error = errors[0];
            }

            for (const [ key, value ] of Object.entries(mappedData)) {
                this.$set(this, key, value);
            }
        },

        async loadPlanningIndicators(from, to, typeId, groupingMode = 'day') {
            if (groupingMode === 'quarterhourly') {
                return this.loadPlanningIndicatorsQuarterHourly(from, to, typeId);
            } else if (groupingMode === 'hourly') {
                return this.loadPlanningIndicatorsPagedCompletely(from, to, typeId);
            } else {
                return this.loadPlanningIndicatorsByDay(from, to, typeId);
            }
        },

        async loadPlanningIndicatorsByDay(from, to, typeId) {
            from = moment(from).format();
            to = moment(to).format();
            const url = '/api/sec/planningindicator/grouped/';
            const params = { storeId: this.$store.state.storeId, from, to, typeId };

            const response = await this.axios({
                method: 'GET',
                url,
                params,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });
            return response.data;
        },

        async loadPlanningIndicatorsPagedCompletely(from, to, typeId) {
            from = moment(from).format();
            to = moment(to).format();
            const url = '/api/sec/planningindicator/grouped/hour';
            const params = { storeId: this.$store.state.storeId, from, to, typeId };

            const response = await this.axios({
                method: 'get',
                url,
                params,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });

            return response.data;
        },

        async loadPlanningIndicatorsQuarterHourly(from, to, typeId) {
            from = moment(from).format();
            to = moment(to).format();
            const url = '/api/sec/planningindicator/grouped/quarterhour';
            const params = { storeId: this.$store.state.storeId, from, to, typeId };

            const response = await this.axios({
                method: 'get',
                url,
                params,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });

            return response.data;
        },

        async loadMarketData(from, to, hourly = false, marketMode = 1, typeCategory = 1, includeTruncWeeks = false, employeeLevel = null) {
            if (!this.hasMarketPermission) {
                return [];
            }

            const marketFrom = moment(from).startOf('month');
            const marketTo = moment(marketFrom).endOf('month').add(1, 'days').startOf('day');

            from = moment(from);
            to = moment(to);

            if (includeTruncWeeks) {
                from = from.startOf('week');
                to = to.endOf('week').add(1, 'day').startOf('day');
            }

            if ([ 3, 4 ].includes(marketMode)) {
                return this.loadPlannedMarketWorkTime(from.format(), to.format(), hourly, marketFrom.format(), marketTo.format(), false, typeCategory, employeeLevel);
            } else {
                return this.loadPlannedMarketWorkTime(from.format(), to.format(), hourly, null, null, false, typeCategory, employeeLevel);
            }
        },

        async loadPlannedMarketWorkTime(from, to, hourly, marketFrom = null, marketTo = null, planned = false, typeCategory = 1, employeeLevel = null) {
            this.marketError = false;
            const requestFrom = moment(from);
            const requestTo = moment(to);
            const requestIncr = hourly ? 24 : 31;
            const requestIncrUnit = hourly ? 'hours' : 'days';

            const loadIndicatorMarket = marketFrom && marketTo;

            const url = `/api/sec/statistics/market/${loadIndicatorMarket ? 'indicator' : 'whole'}/plannedtime/${hourly ? 'hourly' : 'daily'}`;
            const params = { storeId: this.$store.state.storeId }

            const promises = [];
            for (let start = requestFrom; start.isBefore(requestTo); start.add(requestIncr, requestIncrUnit)) {
                let end = moment(start).add(requestIncr, requestIncrUnit).startOf(requestIncrUnit);
                if (end.isAfter(requestTo)) {
                    end = requestTo;
                }

                let data = { from: start.format(), to: end.format() };
                if (employeeLevel != null) {
                    data = { ...data, employeeLevel };
                }
                if (loadIndicatorMarket) {
                    data = {
                        ...data,
                        marketFrom,
                        marketTo,
                        planned,
                        typeCategory,
                        fromPercentage: 80,
                        toPercentage: 120,
                    };
                }

                promises.push(
                    () => this.axios({
                        method: 'POST',
                        url,
                        params,
                        data,
                        headers: {
                            'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                        },
                    }),
                );
            }

            const responses = await this.$helpers.retryPromises(promises, 3);

            const marketData = responses.flatMap(
                ({ status, value: response }) => status === 'fulfilled' ? response.data : [],
            );

            if (responses.find(({ status }) => status === 'rejected')) {
                this.$helpers.error(this.$t('global.notifications.error'), this.$t('roster.error.loadMarketValues'));
                this.marketError = true;
            }

            return marketData;
        },

        async loadMEOData(from, to, planned, indicatorTypeId, groupingMode = 'daily') {
            const url = `/api/sec/planningemployeethreshold/curve/${groupingMode}`;
            const params = { storeId: this.$store.state.storeId };
            const data = {
                from,
                to,
                planned,
                typeId: indicatorTypeId,
            };
            const response = await this.axios({
                method: 'POST',
                url,
                params,
                data,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });
            return response.data.map((entry) => ( { ...entry, planned } ));
        },

        async loadVLHData(from, to, planned, indicatorTypeId, groupingMode = 'daily') {
            const url = `/api/sec/vlhemployeethreshold/curve/${groupingMode}`;
            const params = { storeId: this.$store.state.storeId };
            const data = {
                from,
                to,
                planned,
                typeId: indicatorTypeId,
            };
            const response = await this.axios({
                method: 'POST',
                url,
                params,
                data,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });
            return response.data.map((entry) => ( { ...entry, planned } ));
        },

        //
        // Load statistics
        //
        async loadSumStats(from, to, groupingMode = 'daily') {
            const url = `/api/sec/statistics/storesum/${groupingMode}`;
            const params = { storeId: this.$store.state.storeId };
            const data = {
                from: moment(from).format(),
                to: moment(to).format(),
            };
            const response = await this.axios({
                method: 'POST',
                url,
                params,
                data,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });
            return response.data;
        },

        async loadComparisonData() {
            const months = this.chartSettings.comparisonPeriod || 1;
            const pastFrom = moment(this.startOfMode).startOf('month').subtract(months, 'month').startOf('month');
            const pastTo = moment(this.startOfMode).startOf('month');
            return Promise.all([
                this.loadHistoricDailySumStats(pastFrom, pastTo),
                this.loadMonthlyRegularWorkTime(pastFrom, pastTo),
            ])
                .then(([ dailySumStats, monthlyRegularWorkTime ]) => {
                    this.$set(this.pastComparisonData, 'dailySumStats', dailySumStats);
                    this.$set(this.pastComparisonData, 'monthlyRegularWorkTime', monthlyRegularWorkTime);
                    this.updatePastStats();
                });
        },

        async loadHistoricDailySumStats(from, to) {
            const url = '/api/sec/statistics/storesum/historic/daily';
            const params = { storeId: this.$store.state.storeId };
            const data = {
                from: moment(from).format(),
                to: moment(to).format(),
            };
            const response = await this.axios({
                method: 'POST',
                url,
                params,
                data,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });
            return response.data;
        },

        async loadMonthlyRegularWorkTime(from, to) {
            const fromMoment = moment(from);
            const toMoment = moment(to);

            const url = '/api/sec/statistics/worktimeregular/monthly/employeelevel';
            const params = {
                storeId: this.$store.state.storeId,
                fromMonth: fromMoment.month() + 1,
                fromYear: fromMoment.year(),
                toMonth: toMoment.month() + 1,
                toYear: toMoment.year(),
            };
            const response = await this.axios({
                method: 'GET',
                url,
                params,
                headers: {
                    'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
                },
            });
            return response.data;
        },


        getLocalStorageSettings() {
            if (!this.storeId) return null;
            const settings = localStorage.getItem('pdChartSettings-store' + this.storeId);
            if (settings)
                return JSON.parse(settings);
            else
                return null;
        },

        saveLocalStorageSettings() {
            if (this.storeId)
                localStorage.setItem('pdChartSettings-store' + this.storeId, JSON.stringify(this.chartSettings));
        },


        updateBarWidth() {
            if (this.initBarWidth) {
                if (this.mode === 'monthHourly') {
                    this.barWidth = this.initBarWidth / ( 24 / pdHelper.INTERVAL_MAP['monthHourly'] );
                } else if (this.mode === 'dayQuarterHourly') {
                    this.barWidth = this.initBarWidth / ( 60 / pdHelper.INTERVAL_MAP['dayQuarterHourly'] );
                } else {
                    this.barWidth = this.initBarWidth;
                }
                return;
            }
            const containerWidth = this.$el.clientWidth;
            let columns;
            if (this.mode === 'week') columns = 7 * ( 24 / pdHelper.INTERVAL_MAP.week );
            else if (this.mode === 'day') columns = this.dayModeHours;
            else if (this.mode === 'dayQuarterHourly') columns = this.dayModeHours * ( 60 / pdHelper.INTERVAL_MAP.dayQuarterHourly );
            else {
                columns = moment(this.endDate).diff(this.startDate, 'days');
                if (this.mode === 'monthHourly') {
                    columns /= ( 24 / pdHelper.INTERVAL_MAP.monthHourly );
                }
            }

            if (containerWidth && columns > 0) {
                this.barWidth = ( containerWidth - this.chartPaddingRight ) / columns;
            } else if (this.mode === 'monthHourly') {
                this.barWidth = 6.25;
            } else if (this.mode === 'dayQuarterHourly') {
                this.barWidth = 1.25;
            } else {
                this.barWidth = 50;
            }
        },

        onBarClick(index, event) {
            // TODO: Get key from selected index and store it in this.selectedKey
            this.selectedIndex = index === this.selectedIndex ? null : index;
            this.$emit('selectionChange', this.selectedIndex, event);
            this.onDetailDataChange();
        },

        onBarDblClick(index, event) {
            if (this.mode === 'day' || this.mode === 'dayQuarterHourly') return;
            const startDate = ( this.mode === 'month' || this.mode === 'monthHourly' ) ? this.startDate : this.startOfMode;
            const selectedDate = moment(startDate).add(index * pdHelper.INTERVAL_MAP[this.mode], pdHelper.UNIT_MAP[this.mode]);
            this.$emit('onDayDblClick', selectedDate, index, event);
        },

        onChartUpdate(chart) {
            // Update Chart Height in vuex to adjust sidebar height
            this.$store.commit('setPDChartAreaHeight', { pdChartAreaHeight: chart.chartArea.bottom });
        },

        onDetailDataChange(loading = false) {
            // TODO: Use this.selectedKey to get the correct data
            if (!this.detailStats) return;

            let pdDetailData;
            if (this.selectedIndex === null)
                pdDetailData = this.detailStats;
            else if (this.detailStats.perUnit && Object.values(this.detailStats.perUnit)[this.selectedIndex])
                pdDetailData = Object.values(this.detailStats.perUnit)[this.selectedIndex];

            const indicatorType = ( this.planningIndicatorTypeMap || {} )[this.chartSettings.selectedIndicatorTypeId]
                || { name: null, category: null };
            pdDetailData = {
                ...pdDetailData,
                chartSettings: this.chartSettings,
                lineMode: this.selectedLineMode.stringVal,
                indicatorTypeName: indicatorType.name,
                indicatorTypeCategory: indicatorType.category,
                displayHours: this.chartSettings.displayHours,
            };

            if (pdDetailData) {
                this.$store.commit('setPDDetailData', { pdDetailData });
            }
        },

        updatePastStats() {
            let employeeLevel = null;
            const selectedEmployeeLevels = this.chartSettings.selectedEmployeeLevels || [];
            if (selectedEmployeeLevels.length === 1) {
                employeeLevel = selectedEmployeeLevels[0];
            }
            const pdPastDetailData = this.pdHelper.calculatePastStats(
                this.pastComparisonData.dailySumStats,
                this.pastComparisonData.monthlyRegularWorkTime,
                this.planningIndicatorTypeMap[this.chartSettings.selectedIndicatorTypeId].category,
                employeeLevel,
            );
            this.$store.commit('setPDPastDetailData', { pdPastDetailData })
        },

        openCalculationTypeDropdown(event) {
            this.$helpers.OpenPopup({
                type: 'list',
                elRelative: event.target,
                pointerDirection: 0,
                borderColor: 'var(--contrast-6)',
                background: 'var(--contrast-1)',
                width: '110px',
                componentState: {
                    iconsLeft: true,
                    entries: Object.values(this.calculationTypeOptions).filter(({ value }) => value !== 'vlh' || this.isSuperUser).map(({ value, label, icon, color }) => ( {
                        value,
                        label,
                        icon,
                        color,
                        styles: {
                            backgroundColor: value === this.chartSettings.calculationMode ? 'var(--contrast-2)' : null,
                            padding: '0.75rem',
                            height: '2.25rem',
                        },
                        labelStyles: {
                            fontSize: '0.8rem',
                            fontFamily: 'DistrictProDemiBold',
                            textAlign: 'left',
                            width: '100%',
                            paddingLeft: '0.25rem',
                        },
                        iconStyles: {
                            fontSize: '1rem',
                            width: '2rem',
                            margin: '0 auto',
                        },
                    } )),
                },
                selectCallback: (_, item) => {
                    const value = item.value;
                    if (
                        value === 'meo' &&
                        ( this.meoData || [] ).length === 0 &&
                        ( !this.error || this.error.requestType !== 'meoData' )
                    ) {
                        this.$helpers.OpenAlert({
                            header: this.$t('roster.error.noMeoData'),
                            description:
                                this.$t('roster.error.noMeoDataHelp') + '<br>' +
                                this.$t('roster.error.noMeoDataQuery'),

                            enableExternal: true,
                            externalUrl: 'https://meindienstplan.atlassian.net/l/cp/YbmRNd65',
                            externalLabel: this.$t('roster.error.showHelp'),
                            closeOnExternal: false,
                            acceptLabel: this.$t('roster.comp.createMeo'),
                            cancelLabel: this.$t('global.ui.cancel'),
                            callbackAccept: (popup) => {
                                this.$router.push({
                                    path: '/planningindicator/planningemployeethresholdoverview',
                                    replace: true
                                });
                                popup.hidden = true;
                            },
                        });
                        return;
                    }
                    if (
                        value === 'vlh' &&
                        ( this.vlhData || [] ).length === 0 &&
                        ( !this.error || this.error.requestType !== 'vlhData' )
                    ) {
                        this.$helpers.OpenAlert({
                            header: this.$t('roster.error.noVlhData'),
                            description:
                                this.$t('roster.error.noVlhDataHelp') + '<br>' +
                                this.$t('roster.error.noVlhDataQuery'),

                            // enableExternal: true,
                            // externalUrl: 'https://meindienstplan.atlassian.net/l/cp/YbmRNd65',
                            // externalLabel: 'Hilfeartikel anzeigen',
                            closeOnExternal: false,
                            acceptLabel: this.$t('roster.comp.createVlh'),
                            cancelLabel: this.$t('global.ui.cancel'),
                            callbackAccept: (popup) => {
                                this.$router.push({
                                    path: '/planningindicator/vlhconfigoverview',
                                    replace: true
                                });
                                popup.hidden = true;
                            },
                        });
                        return;
                    }

                    // this.chartSettings.calculationMode = value; / TODO: Uncomment for vue3 migration
                    this.$set(this.chartSettings, 'calculationMode', value);
                    this.saveLocalStorageSettings();
                    this.calculateChartData().catch(() => {
                    });
                },
            });
        },

        openSettingsPopup() {
            this.$helpers.OpenPopup({
                type: 'datafill',
                header: this.$t('roster.comp.personnelUsageConfig'),
                expanded: true,
                centered: true,
                componentState: {
                    selectCallback: async (data) => {
                        const oldVal = { ...this.chartSettings };

                        for (const [ key, value ] of Object.entries(data)) {
                            this.$set(this.chartSettings, key, value);
                        }
                        this.saveLocalStorageSettings();

                        const newVal = this.chartSettings;

                        try {
                            await this.refresh();
                        } catch (e) {
                            console.error(e);
                        }
                        // await this.calculateChartData();
                        // this.chartSettingsChanged(this.chartSettings);
                    },
                    entries: [
                        {
                            label: this.$tc('store.structure.employeeLevel') + ':',
                            key: 'selectedEmployeeLevels',
                            type: 'dropdownsearch',
                            value: this.chartSettings.selectedEmployeeLevels,
                            dropdownSearchState: {
                                selectMultiple: true,
                                items: [
                                    {
                                        value: 1,
                                        label: this.$t('workBalance.payroll.crew'),
                                        selected: this.chartSettings.selectedEmployeeLevels.includes(1),
                                    },
                                    {
                                        value: 2,
                                        label: this.$t('roster.comp.manager'),
                                        selected: this.chartSettings.selectedEmployeeLevels.includes(2),
                                    },
                                ],
                            },
                        },
                        {
                            label: this.$t('roster.view.keyFigure') + ':',
                            key: 'selectedIndicatorTypeId',
                            type: 'dropdownsearch',
                            value: this.chartSettings.selectedIndicatorTypeId,
                            dropdownSearchState: {
                                selectMultiple: false,
                                selectedItem: {
                                    label: this.planningIndicatorTypeMap[this.chartSettings.selectedIndicatorTypeId].name,
                                    value: this.chartSettings.selectedIndicatorTypeId,
                                },
                                items: Object.values(this.planningIndicatorTypeMap || {})
                                    .filter(({ category }) => !!category)
                                    .map(value => ( {
                                        value: value.id,
                                        label: value.name,
                                        selected: value.id === this.chartSettings.selectedIndicatorTypeId,
                                    } )),
                            },
                        },
                        {
                            label: this.$t('store.settings.market') + ':',
                            key: 'selectedMarketMode',
                            type: 'dropdownsearch',
                            value: this.chartSettings.selectedMarketMode,
                            dropdownSearchState: {
                                selectMultiple: false,
                                selectedItem: this.settingsMarketSelectOptions
                                    .map(({ value, text }) => ( { value, label: text } ))
                                    .find(({ value }) => value === this.chartSettings.selectedMarketMode),
                                items: this.settingsMarketSelectOptions.map(({ value, text }) => ( {
                                    value: value,
                                    label: text,
                                    selected: value === this.chartSettings.selectedMarketMode,
                                } )),
                            },
                        },
                        {
                            label: this.$t('roster.comp.showHoursInstead') + ':',
                            key: 'displayHours',
                            type: 'bool',
                            value: this.chartSettings.displayHours,
                        },
                        {
                            label: this.$t('roster.comp.considerPreviousBalance') + ':',
                            key: 'includePrevMonthTime',
                            type: 'bool',
                            // hidden: !this.isSuperUser,
                            value: this.chartSettings.includePrevMonthTime,
                        },
                        {
                            label: this.$t('roster.comp.considerBreaks') + ':',
                            key: 'subtractBreaks',
                            type: 'bool',
                            hidden: false,
                            value: this.chartSettings.subtractBreaks,
                        },
                        {
                            label: this.$t('roster.comp.considerAbsences') + ':',
                            key: 'useExistingPreferences',
                            type: 'bool',
                            hidden: true,
                            value: this.chartSettings.useExistingPreferences,
                        },
                        {
                            label: this.$tc('global.general.absence', 2) + ': (%)',
                            key: 'absenceHoursPercentage',
                            type: 'slider',
                            hidden: this.chartSettings.useExistingPreferences,
                            value: this.chartSettings.absenceHoursPercentage,
                            slider: {
                                hideMin: true,
                                hideMax: true,
                                min: 1,
                                max: 100,
                                value: this.chartSettings.absenceHoursPercentage,
                                step: 1
                            },
                            computed: (datafill, lastVal, entryBeforeUpdate) => {
                                const useExistingPreferences = (
                                    datafill.entries.find(({ key }) => key === 'useExistingPreferences')
                                    || { value: false }
                                ).value;
                                entryBeforeUpdate.hidden = useExistingPreferences;
                                return entryBeforeUpdate;
                            },
                        },
                        {
                            label: this.$t('roster.comp.considerShiftLengths') + ':',
                            key: 'useMeanShiftLength',
                            type: 'bool',
                            hidden: true,
                            value: this.chartSettings.useMeanShiftLength,
                        },
                        {
                            label: this.$t('roster.comp.shiftLength') + ': (h)',
                            key: 'defaultShiftLength',
                            type: 'slider',
                            hidden: this.chartSettings.useMeanShiftLength,
                            value: this.chartSettings.defaultShiftLength,
                            slider: {
                                hideMin: true,
                                hideMax: true,
                                min: 1,
                                max: 24,
                                value: this.chartSettings.defaultShiftLength,
                                step: 0.5
                            },
                            computed: (datafill, lastVal, entryBeforeUpdate) => {
                                const useMeanShiftLength = (
                                    datafill.entries.find(({ key }) => key === 'useMeanShiftLength')
                                    || { value: false }
                                ).value;
                                entryBeforeUpdate.hidden = useMeanShiftLength;
                                return entryBeforeUpdate;
                            },
                        },
                        {
                            label: this.$t('roster.comp.compareMonthlyPeriod'),
                            key: 'comparisonPeriod',
                            type: 'slider',
                            hidden: true,
                            value: this.chartSettings.comparisonPeriod,
                            slider: {
                                hideMin: true,
                                hideMax: true,
                                min: 1,
                                max: 12,
                                value: this.chartSettings.comparisonPeriod,
                                step: 1
                            },
                        },
                    ],
                },
            });
        },

        chartSettingsIndicatorChange(id) {
            if (this.chartSettings.selectedIndicatorTypeId === id) return;
            this.$set(this.chartSettings, 'selectedIndicatorTypeId', id);
            this.saveLocalStorageSettings();
            this.refresh();
        },

        hasDisplayData(key, dataset) {
            const data = this.chartSettings.displayData[key] || [];
            return data.includes(dataset);
        },

        toggleDisplayData(key, dataset) {
            if (this.chartSettings.displayData.lines.includes('feedback') ||
                this.chartSettings.displayData.lines.includes('productivity')) {
                this.resetViewMode();
                return;
            }

            const data = this.chartSettings.displayData[key] || [];
            if (data.includes(dataset)) {
                data.splice(data.indexOf(dataset), 1);
            } else {
                data.push(dataset);
            }
            this.$set(this.chartSettings.displayData, key, data);
            this.saveLocalStorageSettings();
            this.chartData = this.calculateDisplayableChartData(this.rawData);
        },

        toggleViewMode(stat) {
            if (this.chartSettings.displayData.selectedStat !== stat) {
                this.$set(this.chartSettings.displayData, 'bars', []);
                this.$set(this.chartSettings.displayData, 'lines', [ stat ]);
                this.$set(this.chartSettings.displayData, 'selectedStat', stat);
                this.$store.commit('setPDSelectedStat', { pdSelectedStat: stat });
            }
        },

        resetViewMode() {
            this.$set(this.chartSettings.displayData, 'bars', [ 'actual', 'assigned', 'overstaffed', 'free' ]);
            const linesDisplayData = [ 'actual', 'planned' ];
            if (this.hasMarketPermission) {
                linesDisplayData.push('market');
            }
            this.$set(this.chartSettings.displayData, 'lines', linesDisplayData);
            this.$set(this.chartSettings.displayData, 'selectedStat', null);
            this.$set(this.chartSettings, 'splitPredictionLine', false);
            this.$store.commit('setPDSelectedStat', { pdSelectedStat: null });
        },


        cycleIndicators() {
            const indicators = this.settingsIndicatorSelectOptions;
            const id = this.chartSettings.selectedIndicatorTypeId;
            const index = indicators.findIndex((i) => i.value === id);
            const nextIndex = ( index + 1 ) % indicators.length;
            this.chartSettingsIndicatorChange(indicators[nextIndex].value);
        },

        cycleLineMode() {
            if (this.chartSettings.displayData.selectedStat) {
                this.resetViewMode();
            }
            const lineModes = this.lineModeButtonOptions;

            const currentlySelectedLines = this.chartSettings.displayData.lines.filter((l) => ![ 'actual', 'planned' ].includes(l));

            this.$store.commit('setPDSelectedStat', { pdSelectedStat: null });

            switch (this.selectedLineMode.value) {
                case lineModes[0].value:
                    if (this.isSuperUser) {
                        this.$set(this.chartSettings.displayData, 'lines', [
                            ...currentlySelectedLines,
                            'actual',
                            'planned',
                        ]);
                        this.$set(this.chartSettings, 'splitPredictionLine', true);
                    } else {
                        this.$set(this.chartSettings.displayData, 'lines', [
                            ...currentlySelectedLines,
                            'planned',
                        ].filter((l) => l !== 'actual'));
                        this.$set(this.chartSettings.displayData, 'bars', [ 'assigned', 'overstaffed', 'free' ]);
                        this.$set(this.chartSettings, 'splitPredictionLine', false);
                        break;
                    }
                    break;
                // eslint-disable-next-line no-fallthrough
                case lineModes[1].value:
                    this.$set(this.chartSettings.displayData, 'lines', [
                        ...currentlySelectedLines,
                        'planned',
                    ].filter((l) => l !== 'actual'));
                    this.$set(this.chartSettings.displayData, 'bars', [ 'assigned', 'overstaffed', 'free' ]);
                    this.$set(this.chartSettings, 'splitPredictionLine', false);
                    break;
                case lineModes[2].value:
                    this.$set(this.chartSettings.displayData, 'lines', [
                        ...currentlySelectedLines,
                        'actual',
                    ]);
                    this.$set(this.chartSettings.displayData, 'bars', [ 'actual', 'assigned', 'overstaffed', 'free' ])
                    this.$set(this.chartSettings, 'splitPredictionLine', false);
                    break;
                default:
                    this.$set(this.chartSettings.displayData, 'lines', [
                        ...currentlySelectedLines,
                        'actual',
                        'planned',
                    ]);
                    this.$set(this.chartSettings, 'splitPredictionLine', false);
                    break;
            }

            this.saveLocalStorageSettings();
            this.calculateChartData().catch(() => {
            });
        },

        cyclePersonellMode() {
            const personellModes = this.personellModeButtonOptions;
            const selectedBarDefaults = [ 'actual', 'assigned', 'overstaffed', 'free' ];

            if (this.selectedPersonellMode === personellModes[0]) {
                this.$set(this.chartSettings.displayData, 'bars', [ ...selectedBarDefaults ].filter((b) => b !== 'actual'));
            } else {
                this.$set(this.chartSettings.displayData, 'bars', [ ...selectedBarDefaults ]);
            }
            this.saveLocalStorageSettings();
            const stats = this.calculateStats(this.rawData);
            this.chartData = this.calculateDisplayableChartData(this.rawData, stats);
            this.detailStats = stats;
            this.onDetailDataChange();
        },

        /**
         * Used to initially calculate the chart data.
         * Incremental updates should be done via calculateRawData()
         * @returns {Promise<void>}
         */
        async calculateChartData() {
            let monthStart = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            if (this.mode === 'week') {
                monthStart = moment(this.week).startOf('month').startOf('day');
            }

            let monthlyIndicatorSums = {};

            if (this.mode !== 'month') {
                const monthEnd = moment(monthStart).endOf('month').add(1, 'day').startOf('day');
                const filteredMonthlyIndicators = this.pdHelper.convertIndicatorsToFractions(
                    this.pdHelper.filterIndicators(
                        ( this.mode === 'monthHourly' ? this.planningIndicators : this.monthlyPlanningIndicators ),
                        monthStart,
                        monthEnd,
                        'month',
                        this.chartSettings.selectedIndicatorTypeId,
                        'combined',
                    ),
                    this.planningIndicatorTypeMap,
                );
                monthlyIndicatorSums = {
                    actual: this.pdHelper.calculateIndicatorSum(filteredMonthlyIndicators, monthStart, monthEnd, 'actual', 'month')[2],
                    planned: this.pdHelper.calculateIndicatorSum(filteredMonthlyIndicators, monthStart, monthEnd, 'planned', 'month')[2],
                    combined: this.pdHelper.calculateIndicatorSum(filteredMonthlyIndicators, monthStart, monthEnd, 'combined', 'month')[2],
                };
            }

            let planShiftMap = this.planShiftMap;
            if (this.currentWeekShiftTemplateMap) {
                planShiftMap = this.pdHelper.convertShiftTemplateToShifts(
                    this.currentWeekShiftTemplateMap,
                    this.planShiftMap,
                    moment(this.startOfMode),
                    moment(this.endOfMode),
                );
            }

            let marketData = this.marketPlannedWorkTimeData;
            if (marketData && marketData.length > 0) {
                if (this.marketTooSmall) {
                    marketData = null;
                }
            }
            const [ rawChartData, stats, dataMaps ] = await this.pdHelper.calculateRawChartData(
                this.employeeMap,
                this.monthlyRegularWorkTime,
                this.employeeWorkbalanceMap,
                this.sumStatsForMonth,
                this.planningIndicators,
                this.planningIndicatorTypeMap,
                planShiftMap,
                this.actualShiftMap,
                this.actualBreakMap,
                marketData,
                monthStart,
                this.renderFrom,
                this.renderTo,
                this.chartSettings,
                this.mode,
                this.meoData,
                this.vlhData,
                monthlyIndicatorSums,
                this.spotMap,
                this.sumStats,
            );
            this.detailStats = stats;
            this.chartData = this.calculateDisplayableChartData(rawChartData, stats);
            this.cacheDataMaps(dataMaps); //, this.storeId, this.mode, this.dataKey);
            this.onDetailDataChange();
        },

        calculateRawData(dataMaps) {
            return this.pdHelper.combineMaps(dataMaps, this.renderFrom, this.renderTo, this.startOfMode, this.endOfMode, this.mode);
        },

        calculateStats(rawData) {
            return this.pdHelper.calculateStats(rawData, this.renderFrom, this.renderTo, this.mode, this.chartSettings);
        },

        calculateDisplayableChartData(rawData, stats = null) {
            if (!stats) stats = this.calculateStats(rawData);

            if (rawData && stats)
                return this.pdHelper.calculateDisplayableChartData(rawData, stats, this.renderFrom, this.renderTo, this.mode, this.chartSettings, this.planningIndicatorTypeMap);
            else
                return null;
        },

        cacheDataMaps(dataMaps/*, storeId, mode, key*/) {
            // Combine storeId, mode, key etc. to object, hash it and use the hash as the key
            const cachingKey = this.createCachingKey();
            this.$store.dispatch('cachePDData', { cachingKey, data: dataMaps });
        },

        createCachingKey(keyData = {}) {
            return pdHelper.createCachingKey({
                storeId: this.storeId,
                mode: this.mode,
                date: this.dataKey,
                templateView: this.currentWeekShiftTemplateMap,
                selectedIndicatorTypeId: this.chartSettings.selectedIndicatorTypeId,
                ...keyData,
            });
        },
    },
}
</script>

<style scoped>
.pdc-container {
    background-color: var(--contrast-0);
    display: flex;
    flex-direction: column;
    position: unset;
}

.pdc-toolbar {
    display: flex;
    background-color: var(--contrast-1);
    color: var(--contrast-4);
    width: auto;
    height: 40px;
    z-index: 1;
    padding: 0.5rem 0.5rem 0.25rem;
}

.pdc-legend {
    flex: 1;
    display: flex;
    /*justify-content: center;*/
    gap: 2rem;
    padding-right: 2rem;
    padding-left: 2rem;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    padding-bottom: 0.25rem;
}

.pdc-legend::-webkit-scrollbar {
    width: 2px;
    height: 2px;
}

.pdc-legend::-webkit-scrollbar-button {
    width: 0;
    height: 0;
}

.pdc-legend::-webkit-scrollbar-thumb {
    background-color: var(--contrast-3);
    border: 0 none var(--contrast-1);
    border-radius: 50px;
}

.pdc-legend::-webkit-scrollbar-thumb:hover {
    background-color: var(--contrast-5);
}

.pdc-legend::-webkit-scrollbar-thumb:active {
    background-color: var(--contrast-4);
}

.pdc-legend::-webkit-scrollbar-track {
    background-color: var(--contrast-2);
    border: 0 none var(--contrast-1);
    border-radius: 50px;
}

.pdc-legend::-webkit-scrollbar-track:hover {
    background-color: var(--contrast-3);
}

.pdc-legend::-webkit-scrollbar-track:active {
    background-color: var(--contrast-6);
}

.pdc-legend::-webkit-scrollbar-corner {
    background-color: transparent;
}

.pdc-legend-item {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    margin: 0.125rem 0;
    padding: 0.125rem 0.25rem;
    text-wrap: nowrap;
    scroll-snap-align: start;
}

button.pdc-legend-item > * {
    cursor: pointer;
}

button.pdc-legend-item:focus {
    outline: 1px solid var(--contrast-5);
}

.pdc-legend-item > i {
    margin-right: 0.5rem;
    /*color: white;
    border-radius: 50%;
    padding: 0.25rem;*/
}

.pdc-legend-item > span {
    font-size: 0.9rem;
    font-weight: bold;
    color: var(--contrast-4);
}

.pdc-button-container {
    display: flex;
    gap: 1rem;
}

.pdc-button-container > button {
    box-shadow: none;
    border: none;
    padding: 0.125rem 0.5rem;
    font-size: 0.9rem;
}

.selection-stripe {
    height: 6px;
    margin-bottom: -5px;
    margin-left: -5px;
    background-color: #6d8d23;
    z-index: 2;
}

.pdc-loading-container {
    display: grid;
    grid-auto-flow: column;
    justify-content: start;
    align-items: end;
    height: 100%;
    background-color: var(--contrast-0);
}

.pdc-loading-bar {
    background-color: var(--contrast-5);
    opacity: 5%;
    animation: loading-animation 1s infinite alternate;
}

@keyframes loading-animation {
    from {
        opacity: 0.05;
    }
    to {
        opacity: 0.5;
    }
}

.pdc-error-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.pdc-error-heading {
    font-size: 1.5rem;
    color: var(--contrast-5);
    margin-bottom: 1rem;
    z-index: 1;
}

.pdc-error-container > p {
    color: var(--contrast-5);
    font-weight: bold;
    /*font-family: 'DistrictProBold', sans-serif;*/
    z-index: 1;
    margin-bottom: 1rem;
}

.pdc-error-container > button {
    background-color: transparent;
    color: var(--contrast-4);
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    font-weight: bold;
    z-index: 1;
}

.chart-settings-container {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 320px;

    overflow-x: hidden;
    max-width: 0;
    transition: max-width 250ms ease-in-out;

    z-index: 4;

    display: flex;
    flex-direction: column;

    /*backdrop-filter: blur(8px); */
}

.chart-settings-container:after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: var(--contrast-0);
    /*opacity: 50%; */
    z-index: -1;
}

.chart-settings-container.chart-settings-visible {
    max-width: 100%;
}

.chart-settings-container > .chart-settings-body {
    padding: 1rem;
    height: 100%;
    overflow-y: auto;
    text-align: left;
}

.chart-settings-select {
    appearance: auto;
    -moz-appearance: listbox;
    -webkit-appearance: listbox;
    color: var(--contrast-4);
    background: transparent;
    border-color: var(--contrast-4);
    border-radius: 0;
}

.chart-settings-select-append {
    height: calc(100% - 3px);
    color: var(--contrast-4);
    background: transparent;
    border: 1px solid var(--contrast-4);
    border-left: none;
    padding: 0 0.3rem;
    width: auto;
    justify-content: center;
    align-items: center;
    transition: border-color 0.15s ease-in-out;
}

.chart-settings-checkbox-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 1rem;
    color: var(--contrast-4);
}

.chart-settings-checkbox {
    color: var(--contrast-4);
    background-color: transparent;
    box-shadow: none;
    border: 1px solid var(--contrast-4);
    border-radius: 0;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-basis: 1.5rem;
    text-align: center;
}

.chart-settings-text-input {
    width: 5rem;
    text-align: right;
    color: var(--contrast-4);
    background-color: transparent;
    box-shadow: none;
    border-color: var(--contrast-4);
    border-radius: 0;
}
</style>

<style>
.chart-settings-multi-select {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.chart-settings-multi-select option {
    padding: 0.25rem 0.5rem;
}

.chart-settings-multi-select > option.multi-select-option-selected {
    background-color: rgba(109, 141, 33, 0.3);
    color: var(--contrast-4);
}

.pd-kpi-chart {
    color: var(--contrast-4);
    height: 100%;
}

.pd-kpi-chart--blurred {
    filter: blur(20px);
    position: absolute !important;
}

.pd-kpi-chart > .chart-scroll-wrapper {
    z-index: 1;
    overflow-x: clip !important;
}

.pd-kpi-chart > .chart-tooltip {
    z-index: 1;
    top: -40px;
}

.pd-kpi-chart .chart-tooltip > .tooltip-title {
    /* TODO: Add opacity/correct implementation of dark theme */
    /*background-color: var(--contrast-3);*/
}
</style>
